import { Component, OnInit, ComponentFactoryResolver, ChangeDetectorRef } from '@angular/core';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-system-data-entity-input',
    templateUrl: './system-data-entity-input.component.html',
    styleUrls: ['./system-data-entity-input.component.css'],
    standalone: false
})
export class SystemDataEntityInputComponent extends DataEntityInputComponent
  implements OnInit {
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, ref: ChangeDetectorRef, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, ref, context);
  }

  ngOnInit() {}
}
